import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        flexContainer: {
            flexDirection: 'column',
            bg: 'background.base.default',
        },
        productHeaderContainer: {
            width: '100%',
        },
        breadcrumbContainer: {
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            alignItems: 'flex-start',
            bg: 'background.base.default',
        },
        productContainer: {
            display: 'flex',
            flexDirection: ['column', 'column', 'column', 'row'],
            mb: {base: 'small-1.base', md: 'small-1.md', lg: remCalc(45)},
            gap: [0, 0, 'medium.md', 'medium.lg'],
            alignItems: ['center', 'center', 'center', 'flex-start'],
            justifyContent: ['center', 'center', 'center', 'unset'],
            alignSelf: ['stretch', 'stretch', 'stretch', 'unset'],
        },
        imageGalleryBox: {
            flex: 1,
            mr: 0,
            width: ['100%', '100%', '100%', '67%'],
            minW: {base: '100%', lg: remCalc(560), xl: remCalc(729)},
            pb: {base: remCalc(20), sm: remCalc(20), md: 0},
            boxSizing: 'border-box',
            position: 'relative',
        },
        productCard: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            width: ['100%', '100%', '100%', 'auto'],
            gap: ['small-1.base', 'small-1.sm', 'small-1.md', 'small-1.lg'],
            flex: '1 0 0',
            pt: [remCalc(12), remCalc(12), remCalc(20), 0],
        },
        priceBox: {
            display: 'flex',
            flexDirection: 'column',
            gap: {base: 'small-1.base', sm: 'small-1.sm', md: 'small-1.md', lg: 'small-1.lg'},
            width: '100%',
        },
        benefitsAndSpecificationsGroup: {
            display: 'flex',
            flexDirection: 'column',
            gap: ['small-1.base', 'small-1.sm', 'small-1.md', 'small-1.lg'],
        },
        priceAndKlarnaBox: {
            display: 'flex',
            flexDirection: 'column',
            mt: 'xxsmall.base',
            gap: ['xxsmall.base', 'xxsmall.sm', 'xxsmall.md', 'xxsmall.lg'],
        },
        benefitsAndBannerBox: {
            display: 'flex',
            flexDirection: 'column',
            gap: {base: remCalc(24), lg: remCalc(16)},
        },
        inventoryLabelContainer: {
            pt: [remCalc(24), remCalc(24), remCalc(24), remCalc(16)],
        },
        recommendationsSections: {
            width: '100%',
            alignItems: 'stretch',
            gap: ['small-1.base', 'small-1.sm', 'small-1.md', 'small-1.lg'],
        },
        horizontalDivider: {
            color: 'border.light',
            display: ['none', 'none', 'block', 'none'],
        },
        preorderLabel: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: remCalc(2),
            maxW: remCalc(398),
        },
        preorderLabelTitle: {
            textStyle: 'body-small',
            color: 'foreground.neutral.default',
            fontWeight: 'medium',
        },
        preorderLabelDate: {
            textStyle: 'body-small',
            color: 'foreground.neutral.default',
            fontWeight: 'normal',
        },
        backorderLabelTitle: {
            textStyle: 'body-small',
            color: 'foreground.neutral.default',
            fontWeight: 'medium',
        },
        backorderLabelDate: {
            textStyle: 'body-small',
            color: 'foreground.neutral.default',
            fontWeight: 'normal',
        },
        backorderDiscoverLink: {
            textStyle: 'body-xsmall',
            color: 'foreground.neutral.default',
            textDecoration: 'underline',
        },
        orderReviewContainer: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: ['xxsmall.base', 'xxsmall.md', 'xxsmall.lg', 'xxsmall.xl'],
            pt: ['xsmall.base', 'xsmall.md', 'xsmall.lg', 'xsmall.xl'],
        },
        orderReviewHeader: {
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between',
            cursor: 'pointer',
            bg: 'transparent',
            border: 'none',
            pb: ['xxxsmall.base', 'xxxsmall.md', 'xxxsmall.lg', 'xxxsmall.xl'],
            textAlign: 'left',
        },
        orderReviewTitle: {
            textStyle: 'body-medium',
            color: 'foreground.neutral.default',
            fontWeight: 'medium',
        },
        orderReviewChevron: {
            display: 'flex',
            w: remCalc(28),
            h: remCalc(28),
            justifyContent: 'center',
            alignItems: 'center',
            color: 'foreground.neutral.dim',
        },
        orderReviewChevronIcon: {
            boxSize: remCalc(16),
            color: 'foreground.neutral.subtle',
        },
        orderReviewItemsList: {
            alignItems: 'flex-start',
            gap: ['xxsmall-1.base', 'xxsmall-1.md', 'xxsmall-1.lg', 'xxsmall-1.xl'],
            pb: ['xsmall.base', 'xsmall.md', 'xsmall.lg', 'xsmall.xl'],
        },
        orderReviewItem: {
            textStyle: 'body-small',
            color: 'foreground.neutral.default',
            fontWeight: 'medium',
        },
        orderReviewProductRow: {
            alignItems: 'center',
            gap: ['xxxsmall-1.base', 'xxxsmall-1.md', 'xxxsmall-1.lg', 'xxxsmall-1.xl'],
        },
        orderReviewProductIcon: {
            boxSize: remCalc(16),
            color: 'foreground.neutral.default',
        },
        orderReviewAccessoryRow: {
            alignItems: 'center',
            gap: ['xxxsmall-1.base', 'xxxsmall-1.md', 'xxxsmall-1.lg', 'xxxsmall-1.xl'],
        },
        orderReviewAccessoryIcon: {
            boxSize: remCalc(16),
            color: 'foreground.neutral.default',
        },
        orderReviewCareRow: {
            alignItems: 'center',
            gap: ['xxxsmall-1.base', 'xxxsmall-1.md', 'xxxsmall-1.lg', 'xxxsmall-1.xl'],
        },
        orderReviewCareIcon: {
            boxSize: remCalc(16),
            color: 'foreground.neutral.default',
        },
        orderReviewPriceRow: {
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            gap: remCalc(4),
        },
        orderReviewPriceCard: {
            flex: 1,
        },
        orderReviewCurrentPrice: {
            textStyle: 'head-small',
            color: 'text.default',
            fontWeight: 'bold',
        },
        orderReviewListPrice: {
            textStyle: 'body-medium',
            color: 'text.secondary',
            textDecoration: 'line-through',
        },
        orderReviewDiscount: {
            textStyle: 'body-medium',
            color: 'text.secondary',
        },
        orderReviewInfoIcon: {
            boxSize: remCalc(14),
            color: 'text.secondary',
        },
        infoIcon: {
            boxSize: remCalc(14),
            color: 'foreground.neutral.default',
        },
    },
}
